module.exports = __webpack_public_path__ + "static/media/cisco.b81e29e7.png";